import {PublicWorkExperienceItem} from 'Interfaces'

export const Sort = (
  ed1: PublicWorkExperienceItem,
  ed2: PublicWorkExperienceItem
) => {
  return ed2.experience - ed1.experience
}
